import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('paypal_transactions_list')
        .setAdditionalRoutes([
            'paypal_transaction_matching',
        ]),
    MenuEntry.create()
        .setRoute('paypal_transactions_list_managed_by_accounting')
        .setAdditionalRoutes([
            'paypal_transaction_matching',
        ]),
];
